module.exports = __webpack_public_path__ + "static/img/pc.78773ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pc.png
// module id = nfxX
// module chunks = 1